























import { Mixins, Component, Prop, Ref } from 'vue-property-decorator'
import MixinForm from 'components/presenter/item/topic/editor/MixinForm'
import * as Y from 'yjs'
import Delta from 'quill-delta'
import { svgIcon } from 'src/assets/icons'
import FileFolder from 'components/presenter/item/FileFolder.vue'
import MarkdownEditorCrdt from 'components/MarkdownEditorCrdt.vue'
import { Item } from 'src/graphql/types'

@Component({
  components: {
    FileFolder,
    MarkdownEditorCrdt
  }
})
export default class ItemTopicSlidesEditorFormSlide extends Mixins(MixinForm) {

  @Prop({ default: '7em' })
  readonly minHeight!: string

  @Ref()
  readonly editor!: MarkdownEditorCrdt

  @Ref()
  readonly folder!: FileFolder

  get text (): Y.Doc {
    return this.slide.text
  }

  get notes (): Y.Doc {
    return this.slide.notes
  }

  get toolbar () {
    return [{
      hotkey: '⇧⌘A',
      name: 'file',
      tipPosition: 'n',
      tip: 'Insert File',
      className: 'right',
      icon: svgIcon('attach-outline'),
      click: () => {
        this.folder.show()
      }
    }]
  }

  created () {
    const slidesTexts: Json = {}
    slidesTexts[`${this.slide.id}:text`] = []
    slidesTexts[`${this.slide.id}:notes`] = []
    this.item.data?.update({ slidesTexts })
  }

  update (delta: Delta) {
    this.text.transact(() => {
      this.text.getText().applyDelta(delta.ops)
    }, 'SLIDE_TEXT_EDIT')
  }

  updateNotes (delta: Delta) {
    this.notes.transact(() => {
      this.notes.getText().applyDelta(delta.ops)
    }, 'SLIDE_NOTES_EDIT')
  }

  fileSelect (file: Json) {
    this.folder.hide()
    const fileName = file.src.replace(/(\/\d+)+\/.{36}\./g, '')
    if (file.type.startsWith('image')) {
      this.editor.content.insertValue(`![${fileName}](${file.src})`)
    } else {
      this.editor.content.insertValue(`[${fileName}](${file.src})`)
    }
  }
}
